<template>
  <div>
    <language-add-new
        :is-add-new-language-sidebar-active.sync="isAddNewLanguageSidebarActive"
        :id = "id"
        :data="languageData"
        @refetch-data="refetchData"
    >

    </language-add-new>

    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="搜尋..."
              />
              <b-button
                variant="primary"
                @click="handleCreate"
              >
                <span class="text-nowrap" v-if="ability.can('create','contracttemplates')">Add Language</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

    <b-table
        ref="refLanguageListTable"
        class="language-relative"
        :items="fetchLanguages"
        responsive
        stacked="md"
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
    >
    <template #cell(working_paper_bit)="data">
        <feather-icon 
        v-if="data.item.working_paper_bit"
        icon="CheckIcon"
        size="18"
        class="mr-50 text-success"
        />
    </template>
    <template #cell(invoicing_bit)="data">
        <feather-icon 
        v-if="data.item.invoicing_bit"
        icon="CheckIcon"
        size="18"
        class="mr-50 text-success"
        />
    </template>
    <template #cell(timesheet_bit)="data">
        <feather-icon 
        v-if="data.item.timesheet_bit"
        icon="CheckIcon"
        size="18"
        class="mr-50 text-success"
        />
    </template>
    <template #cell(action)="data">
        <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item v-if="ability.can('update','contracttemplates')" @click="handleEdit(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="ability.can('delete', 'contracttemplates')" @click="confirmDelete(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
    </template>
    </b-table>  
    <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalLanguages"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>

    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import contractStoreModule from "../contractStoreModule";
import useLanguagesList from "./useLanguagesList";
import LanguageAddNew from "./LanguageListAddNew.vue"

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    LanguageAddNew,
  },
  methods:{
      handleCreate(){
          this.id = 0
          this.resetLanguageData()
          this.isAddNewLanguageSidebarActive = true
      },
      handleEdit(item){
        this.id = item.id
        this.languageData.id = item.id
        this.languageData.language_name = item.language_name
        this.languageData.language_remark = item.language_remark
        this.languageData.party_a_title = item.party_a_title
        this.languageData.party_a_address_title = item.party_a_address_title
        this.languageData.party_b_title = item.party_b_title
        this.languageData.party_b_address_title = item.party_b_address_title
        this.languageData.party_b_address = item.party_b_address
        this.languageData.br_no_text = item.br_no_text
        this.languageData.br_no = item.br_no
        this.languageData.contract_description = item.contract_description
        this.languageData.address_title = item.address_title
        this.languageData.address1 = item.address1
        this.languageData.address2 = item.address2
        this.languageData.address3 = item.address3
        this.languageData.contract_email = item.contract_email
        this.languageData.contract_website = item.contract_website
        this.languageData.party_b = item.party_b
        this.languageData.agreement_description = item.agreement_description
        this.languageData.signature_title = item.signature_title
        this.languageData.signature_name_title = item.signature_name_title
        this.languageData.signature_title_title = item.signature_title_title
        this.languageData.signature_contact_number_title = item.signature_contact_number_title
        this.isAddNewLanguageSidebarActive = true
      }, resetLanguageData(){
        this.languageData = {
            id: 0,
            language_name: '',
            language_remark: '',
            party_a_title: '',
            party_a_address_title: '',
            party_b_title: '',
            party_b_address_title: '',
            party_b_address: '',
            br_no_text: '',
            br_no: '',
            contract_description: '',
            address_title: '',
            address_1: '',
            address_2: '',
            address_3: '',
            contract_email: '',
            contract_website: '',
            party_b: '',
            agreement_description: '',
            signature_title: '',
            signature_name_title: '',
            signature_title_title: '',
            signature_contact_number_title: '',
        }
      },
      confirmDelete(id){
        this.$swal({
        title: '確認刪除?',
        text: 'Your action is final and you will not be able to retrieve the language.',
        showCancelButton: true,
        confirmButtonText: '刪除',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
      .then(result => {
        if (result.value) {
          this.$store.dispatch("setting-contract/deleteLanguage", {'id': id})
          .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                showClass: {
                  popup: 'animate__animated animate__bounceIn',
                },
                buttonsStyling: false,
              })
              this.refetchData()
          }).catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                showClass: {
                  popup: 'animate__animated animate__bounceIn',
                },
                buttonsStyling: false,
              })

          })
        }
      })
      },
  },
  data(){
    return {
        id:0,
        languageData:{},
    }  
  },
  setup() {
    const SETTING_LANGUAGE_STORE_MODULE_NAME = "setting-contract";

    if (!store.hasModule(SETTING_LANGUAGE_STORE_MODULE_NAME))
      store.registerModule(
        SETTING_LANGUAGE_STORE_MODULE_NAME,
        contractStoreModule
      );

    onUnmounted(() => {
      if (store.hasModule(SETTING_LANGUAGE_STORE_MODULE_NAME))
        store.unregisterModule(SETTING_LANGUAGE_STORE_MODULE_NAME);
    });

    const isAddNewLanguageSidebarActive = ref(false);

    const {
      fetchLanguages,
      tableColumns,
      perPage,
      currentPage,
      totalLanguages,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refLanguageListTable,
      refetchData,
      ability,
    } = useLanguagesList();

    return {
      //Sidebar
      isAddNewLanguageSidebarActive,

      fetchLanguages,
      tableColumns,
      perPage,
      currentPage,
      totalLanguages,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refLanguageListTable,
      refetchData,
      avatarText,
      ability,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>